import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/services';
import { ApiResponse } from '../../../core/models';
import { withCaptcha } from '../../../core/interceptors/captcha.context';
import {
  ClientInquiryResponseDTO,
  ClientListRequestDTO,
  CreateClientRequestDTO,
  CreateClientResponseDTO,
} from '../../models/shared.model';
import { ClientsRepository } from '../contracts/clients.repository';

@Injectable({
  providedIn: 'root',
})
export class ClientsHttpRepository extends BaseApiService implements ClientsRepository {
  private readonly controllerUrl = '/Client/';

  /**
   * POST `/api/v1/Client/create` (body `CreateClientRequest`, respuesta `Response<ClientDTO>`).
   * `baseUrl` de configuración ya incluye el prefijo `/api/v1`.
   */
  createClient(
    request: CreateClientRequestDTO
  ): Observable<HttpResponse<ApiResponse<CreateClientResponseDTO>>> {
    const payload = {
      businessName: request.businessName.trim(),
      entityType: request.entityType.trim(),
      businessType: request.businessType.trim(),
      scacCode: request.scacCode.trim(),
      address: request.address.trim(),
      city: request.city.trim(),
      state: request.state.trim(),
      postalCode: request.postalCode.trim(),
      country: request.country.trim(),
      phone: request.phone.trim(),
      contactName: request.contactName.trim(),
      email: request.email.trim(),
    };

    return this.http.post<ApiResponse<CreateClientResponseDTO>>(
      `${this.baseUrl}/Client/create`,
      payload,
      { observe: 'response', context: withCaptcha() },
    );
  }

  listClients(
    request: ClientListRequestDTO
  ): Observable<HttpResponse<ApiResponse<ClientInquiryResponseDTO>>> {
    const payload = {
      businessName: request.businessName.trim(),
    };

    return this.http.post<ApiResponse<ClientInquiryResponseDTO>>(
      `${this.baseUrl}${this.controllerUrl}client-list`,
      payload,
      { observe: 'response' },
    );
  }

}
